import { useCallback, useEffect, useRef, useState } from 'react'
import { confirmTimetableRequest } from '@/helpers/confirmTimetableRequest'
import TimetableConflicts from '@/components/common/TimetableConflicts'

export const useTimetableConflicts = () => {
  const [confirmation, setConfirmation] = useState(null)
  const pending = useRef(null)
  const active = useRef(true)

  useEffect(() => {
    active.current = true
    return () => {
      active.current = false
      pending.current?.(false)
      pending.current = null
    }
  }, [])

  const finish = useCallback((accepted) => {
    const resolve = pending.current
    pending.current = null
    setConfirmation(null)
    resolve?.(accepted)
  }, [])

  const confirmRequest = useCallback((request, options = {}) => (
    confirmTimetableRequest(request, (data) => new Promise((resolve) => {
      pending.current = resolve
      setConfirmation({ data, checkOnly: options.checkOnly })
    }), { ...options, isActive: () => active.current })
  ), [])

  return {
    confirmRequest,
    conflictsModal: confirmation ? (
      <TimetableConflicts
        data={confirmation.data}
        checkOnly={confirmation.checkOnly}
        onConfirm={() => finish(true)}
        onCancel={() => finish(false)}
      />
    ) : null,
  }
}
